<template>
    <h2 v-if="false == hasTimeslots" class="h4 pt-2 pb-1 event-dates">{{ dateString }}</h2>
    <div v-for="sessionDay in sessionDays" :key="sessionDay.displayDate">
        <div v-if="null != sessionDay.displayDate && '' != sessionDay.displayDate && hasTimeslots" class="row pt-2 pb-1 calendar-date">
          <h3 class="col list-separator"><DateDisplay :calendar_date="sessionDay.displayDate" /></h3>
        </div>
        <div v-for="session in sessionDay.sessions" :key="session.id">
            <SessionListItem :item="session" :removable="removableItems" :visible="session.visible"
                             :hasTimeslots="hasTimeslots" :showRoomCollapsed="showRoomsCollapsed"
                             :showSessionButton="showSessionButtons" :showMaterials="showMaterials"
                             :isMySchedule="isMySchedule" :showAssessment="showAssessment"
                             @session-added="sessionAddedHandler" @session-removed="sessionRemovedHandler"
                             @presenterIdChanged="presenterIdChangedHandler" />
            <div v-if="session.id == currentSessionId" id="scroll-to-now"></div>
        </div>
  </div>

</template>

<script>
import DateDisplay from '@/components/DateDisplay'
import dayjs from 'dayjs'
import {Notyf} from "notyf";
import SessionListItem from '@/components/SessionListItem'
import {sessionsGroupByTimeslots, sessionsMarkScheduleConflicts, sessionsSortByDateAndTime, sessionsSortWithinTimeslots} from '@/shared/Utilities'
import {useEventsStore} from '@/store/events.js'

export default {
    name: 'SessionList',

    components: {
        DateDisplay,
        SessionListItem,
    },

    computed: {
        sessionDays() {
            let sessions = []
            for (let i = 0; i < this.copyOfSessions.length; i++) {
                sessions.push(this.copyOfSessions[i])
            }
            sessions = sessionsSortByDateAndTime(sessions)
            sessions = sessionsMarkScheduleConflicts(sessions)
            sessions = sessionsGroupByTimeslots(sessions)
            sessions = sessionsSortWithinTimeslots(sessions)
            if (559 > screen.availWidth) {
                sessions = sessions.map((session) => {
                    session.timeslotLabel = session.timeslotLabel.replace('<br />', ' ')
                    return session
                })
            }

            let sessionDays = []
            let daySessions = []
            let displayDate = ''
            for (let i = 0; i < sessions.length; ++i) {
                if (displayDate != sessions[i].timeslot.date.calendar_date) {
                    if (0 < daySessions.length) {
                        sessionDays.push({displayDate:displayDate, sessions:daySessions})
                        daySessions = []
                    }
                    displayDate = sessions[i].timeslot.date.calendar_date
                }
                daySessions.push(sessions[i])
            }
            sessionDays.push({displayDate:displayDate, sessions:daySessions})
            return sessionDays
        },
    },

    created() {
        // Count the venues
        let venueIds = []
        this.copyOfSessions = []
        for (let i = 0; i < this.sessions.length; ++i) {
            this.copyOfSessions.push(this.sessions[i])
            if (this.sessions[i].room && false == venueIds.includes(this.sessions[i].room.venue.id)) {
                venueIds.push(this.sessions[i].room.venue.id)
            }
        }
        if (1 < venueIds.length) { // If more than one, show the venue names in the list items
            for (let i = 0; i < this.copyOfSessions.length; ++i) {
                this.copyOfSessions[i].showVenueName = true
            }
        }

        // Find the scroll-to session (most closely matching current time)
        const now = dayjs()
        for (let i = 0; i < this.copyOfSessions.length; ++i) {
            const startTime = dayjs(this.copyOfSessions[i].timeslot.date.calendar_date + ' ' + this.copyOfSessions[i].timeslot.start_time)
            const endTime = dayjs(this.copyOfSessions[i].timeslot.date.calendar_date + ' ' + this.copyOfSessions[i].timeslot.end_time)
            if (startTime <= now && now < endTime) {
                this.currentSessionId = this.copyOfSessions[i].id
                break
            }
        }
        if (this.viewParent === 'mySchedule'){
            this.isMySchedule = true
        }
    },

    data() {
        return {
            copyOfSessions: null,
            currentSessionId: 0,
            documentTitle: 'My PaTTAN Events Schedule',
            eventsStore: useEventsStore(),
            isMySchedule:false,
        }
    },

    emits: [
        'presenterIdChanged',    
        'sessionAdded',
        'sessionRemoved',
    ],

    methods: {
        presenterIdChangedHandler(value) {
            this.$emit('presenterIdChanged', value)
        },

        sessionAddedHandler(value) {
            this.$emit('sessionAdded', value)
        },

        sessionRemovedHandler(value) {
          this.$emit('sessionRemoved', value)
        },

        timeslotToMessageString(timeslot) {
            const dummyDate = '1971-01-01 '
            return dayjs(timeslot.date.calendar_date).format('dddd') + ' ' +
                   dayjs(dummyDate + timeslot.start_time).format('h:mmA') + ' - ' + dayjs(dummyDate + timeslot.end_time).format('h:mmA')
        }

    },

    mounted() {
        this.$nextTick(() => {
            const scrollToElement = document.getElementById('scroll-to-now')
            if (null != scrollToElement) {
                scrollToElement.scrollIntoView()
            }
        })

        // Gather up a list of all timeslots where conflicts occur
        const conflictTimeslots = []
        for (let i in this.sessions) {
            if (0 < this.sessions[i].conflictingSessions.length) {
                let alreadyListed = false
                for (let j in conflictTimeslots) {
                    if (conflictTimeslots[j].id == this.sessions[i].timeslot.id) {
                        alreadyListed = true
                        break
                    }
                }
                if (false == alreadyListed) {
                    conflictTimeslots.push(this.sessions[i].timeslot)
                }
            }
        }

        // If there are conflicts, and we haven't yet nagged about them, nag about them
        if (0 < conflictTimeslots.length && false == this.eventsStore.hasDisplayedConflictNag) {
            let conflictAlertMessage = ''
            for (let i in conflictTimeslots) {
                conflictAlertMessage += '<br>' + this.timeslotToMessageString(conflictTimeslots[i])
            }
            let phrase = 1 == conflictTimeslots.length ? 'this timeslot' : 'these timeslots'
            conflictAlertMessage = 'You have schedule conflicts in ' + phrase + ':' + conflictAlertMessage +
                                   '<br>You cannot receive CE credit for overlapping sessions'
            const notyf = new Notyf()
            notyf.error({dismissible: true, duration: 0, message: conflictAlertMessage, position: {x: 'center', y: 'top'}})

            this.eventsStore.hasDisplayedConflictNag = true
        }
    },

    props: {
        dateString: {
            type: String,
            default: '',
        },
        hasTimeslots: {
            type: Boolean,
            default: true,
        },
        removableItems: {
            type: Boolean,
            default: false
        },
        sessions: Array,
        showMaterials: {
            type: Boolean,
            default: false,
        },
        showRoomsCollapsed: {
            type: Boolean,
            default: false
        },
        showSessionButtons: {
            type: Boolean,
            default: true
        },
        viewParent:{
            type: String,
            default: ''
        },
        showAssessment: {
            type: Boolean,
            default: false
        },
    },
}
    
</script>

<style scoped>

.calendar-date {
    background-color: var(--phoenix-navbar-vertical-bg-color);
    position: sticky;
    top: 75px;
    border-radius: 0.3rem;
}

.event-dates {
    border-bottom: solid var(--phoenix-1100) 1px; 
}

.list-separator {
    font-size: 1rem;
}

</style>